<template>
  <div>
    <v-container fluid class="my-0 py-0">
      <v-card class="mt-3" :elevation="8">
        <TabellaRichieste
          @aggiornato_intervento="$emit('aggiornato_intervento')"
          :allow_cod_richiesta_custom="true"
          :allow_doppia_descrizione="true"
          :allow_update_ambiti_manutentivi_custom_dg_marine="true"
          :bacheca_intervento_visible="bacheca_intervento_visible"
          :bacheca_richiesta_visible="bacheca_richiesta_visible"
          :back_as_landing_page="true"
          :checkbox="'interno'"
          :checkbox_default_val="0"
          :cod_filtro_sede="'NAVE'"
          :concessionari_visible="true"
          :config_area="config_area"
          :config_macchinario="config_macchinario"
          :config_marca="config_marca"
          :config_matricola="config_matricola"
          :config_modello="config_modello"
          :config_sede="config_sede"
          :config_stanza="config_stanza"
          :config_stato="config_stato"
          :config_stato_dettaglio="config_stato_dettaglio"
          :config_struttura="config_struttura"
          :config_zona="config_zona"
          :config_zona_geografica="config_zona_geografica"
          :dettaglio_step_visible="dettaglio_step_visible"
          :get_sedi_from_macchine="true"
          :go_back_visible="true"
          :headers_allegati_scelti="headers_allegati_scelti"
          :headers_interventi_scelti="headers_interventi_scelti"
          :headers_richieste_scelti="headers_richieste_scelti"
          :headers_scelti_anagrafiche="headers_scelti_anagrafiche"
          :icona_gestione_sedi_fornitori="'mdi-ferry'"
          :IsDgMarine="true"
          :preventivo_visible="true"
          :rotta_back="'/home/naval'"
          :show_attivita_in_intervento="show_attivita_in_intervento"
          :show_data_prevista_input="false"
          :show_filtro_cod_richiesta="false"
          :show_filtro_data_richiesta="false"
          :show_filtro_descrizione="true"
          :show_filtro_marca="true"
          :show_filtro_matricola="true"
          :show_filtro_modello="true"
          :show_filtro_richiedente="false"
          :show_filtro_sede="true"
          :show_filtro_stato="false"
          :show_filtro_stato_dettaglio="false"
          :show_filtro_struttura="false"
          :show_filtro_tipo_richiesta="true"
          :show_filtro_unico="false"
          :show_filtro_urgenza="false"
          :show_invio_email="false"
          :show_referente_input="false"
          :show_riepilogo_costi="true"
          :show_tab_costi="false"
          :stato_richiesta_visible="true"
          :stato_richiesta_2_visible="true"
          :tempo_stimato_visible="false"
          :tipo_getfornitori="tipo_getfornitori"
          :titolo_intervento_visible="true"
          :toolbar_style="'digitalmarine'"
          :calendar="calendar"
          urgenza_richiesta_default_val="LOW"
          ref="tabella_richieste"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import TabellaRichieste from "@/components/MANUTENZIONE/TabellaRichieste.vue";

export default {
  name: "GestioneSintetica",
  props: {
    calendar: { type: Boolean, default: false },
  },
  components: {
    TabellaRichieste,
  },
  data() {
    return {
      // Variabili d'appoggio

      bacheca_intervento_visible: false,
      bacheca_richiesta_visible: false,
      config_area: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_macchinario: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_marca: {
        label: {
          singolare: "Marca",
          plurale: "Marche",
        },
        visibility: true,
      },
      config_matricola: {
        label: {
          singolare: "Matricola HIN",
          plurale: "Matricole HIN",
        },
        visibility: true,
      },
      config_modello: {
        label: {
          singolare: "Modello e Num. Scafo",
          plurale: "Modelli e Num. Scafo",
        },
        visibility: true,
      },
      config_sede: {
        label: { singolare: "Barca", plurale: "Barche" },
        visibility: true,
      },
      config_stanza: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_stato: {
        label: { singolare: "Stato", plurale: "Stati" },
        visibility: true,
      },
      config_stato_dettaglio: {
        label: { singolare: "Stato dettaglio", plurale: "Stati dettagli" },
        visibility: true,
      },
      config_struttura: {
        label: {
          singolare: "Zona di Manutenzione",
          plurale: "Zone di Manutenzione",
        },
        visibility: true,
      },
      config_zona: {
        label: { singolare: "", plurale: "" },
        visibility: false,
      },
      config_zona_geografica: {
        label: { singolare: "Zona Geografica", plurale: "Zone Geografiche" },
        visibility: true,
      },
      dettaglio_step_visible: false,
      show_attivita_in_intervento: false,
      tipo_getfornitori: "digitalmarine",
      // Modal

      // Array
      headers_allegati_scelti: [
        {
          text: "Scarica",
          value: "scarica",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des_allegato",
          sortable: false,
        },
        {
          text: "Data Validità",
          value: "data_validita",
          sortable: false,
        },
        {
          text: "Caricato da",
          value: "nominativo",
          sortable: false,
        },
        {
          text: "Preview",
          value: "preview",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      headers_interventi_scelti: [
        {
          text: "Modifica",
          sortable: false,
          value: "modifica",
        },
        {
          text: "Titolo",
          sortable: false,
          value: "des_intervento",
        },
        {
          text: "Importo (€)",
          sortable: false,
          value: "importo_totale",
        },
        {
          text: "Fornitore",
          sortable: false,
          value: "ragione_sociale",
        },
        {
          text: "Ambito Manutentivo",
          sortable: false,
          value: "des_tipo_intervento",
        },
        {
          text: "Tipo Manutenzione",
          value: "des_tipo_manutenzione",
          sortable: false,
        },
        {
          text: "Data Schedulata",
          value: "data_schedulata",
          sortable: false,
        },
        {
          text: "Stato Operazioni",
          value: "des_stato_operativo",
          sortable: false,
        },
      ],
      headers_richieste_scelti: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: true,
        },
        {
          text: "Tipo Claim",
          value: "des_tipo_richiesta",
          sortable: true,
        },
        {
          text: "N. Claim",
          value: "cod_richiesta_custom",
          sortable: true,
        },
        {
          text: "Nome Barca",
          value: "des_sede",
          sortable: true,
        },
        {
          text: "Modello e Num. Scafo",
          value: "modello",
          sortable: true,
        },
        {
          text: "Matricola HIN",
          value: "matricola",
          sortable: true,
        },
        {
          text: "Marca",
          value: "marca",
          sortable: true,
        },
        {
          text: "Zona Geografica",
          value: "des_reparto",
          sortable: true,
          filterable: false,
        },
        {
          text: "Descrizione",
          value: "descrizione",
          sortable: true,
          filterable: false,
        },
        {
          text: "Stato",
          value: "des_stato",
          sortable: false,
          align: "center",
          filterable: false,
        },
        {
          text: "Stato Dettaglio",
          value: "des_stato_2",
          sortable: false,
          align: "center",
          filterable: false,
        },
        {
          text: "Data Richiesta",
          value: "data_richiesta",
          sortable: true,
          filterable: false,
        },
      ],
      headers_scelti_anagrafiche: [
        { text: "Dettagli", sortable: false, value: "dettagli" },
        { text: "Ragione Sociale", sortable: false, value: "ragione_sociale" },
        { text: "Sede Operativa", sortable: false, value: "sede_operativa" },
        { text: "Marchi", sortable: false, value: "concessionari" },
        {
          text: "Ambiti Manutentivi",
          sortable: false,
          value: "ambiti_manutentivi",
        },
        { text: "Telefono", sortable: false, value: "telefono" },
        { text: "Mail", sortable: false, value: "email" },
      ],
    };
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
